import { useCallback, useSyncExternalStore } from 'react';
import {
  acceptAllCookies,
  closeCookieSettings,
  getCookieConsentState,
  hasConsent,
  openCookieSettings,
  rejectNonEssentialCookies,
  saveCookieConsent,
  subscribeCookieConsent,
  type ConsentCategories,
  type ConsentCategory,
} from './cookieConsentStore';

/** React binding for the cookie consent store. */
export function useCookieConsent() {
  const state = useSyncExternalStore(subscribeCookieConsent, getCookieConsentState, getCookieConsentState);

  const isAllowed = useCallback(
    (category: ConsentCategory) => (category === 'essential' ? true : state.consent?.categories[category] === true),
    [state],
  );

  return {
    consent: state.consent,
    /** No valid choice yet: the banner must be shown. */
    needsDecision: state.consent === null,
    /** The settings were reopened on purpose (footer link). */
    settingsRequested: state.settingsRequested,
    hasConsent: isAllowed,
    acceptAll: acceptAllCookies,
    rejectNonEssential: rejectNonEssentialCookies,
    save: (categories: Partial<ConsentCategories>) => saveCookieConsent(categories),
    openSettings: openCookieSettings,
    closeSettings: closeCookieSettings,
  };
}

export { hasConsent, openCookieSettings };
